<p-table
  #searchResultsList
  styleClass="table-dark-header"
  data-testId="search-results-list"
  [value]="orders"
  [lazy]="true"
  [dataKey]="'orderNumber'"
  (onPage)="onPageChange($event)"
  [first]="tableParams.first"
  [rows]="tableParams.rowsPerPage"
  [paginator]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  [totalRecords]="totalRecords"
  [loading]="loading"
  [scrollable]="false"
  (onSort)="customSort($event)"
  [sortField]="tableParams.sortField"
  [sortOrder]="tableParams.sortOrder"
  [expandedRowKeys]="expandedRows"
  [showCurrentPageReport]="true" 
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} items"
>
  <!-- scrollHeight="400px" -->

  <!-- Table header -->
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="number" scope="col">
        Order Number
        <p-sortIcon field="number"></p-sortIcon>
      </th>
      <th scope="col" pSortableColumn="account"  *ngIf="!externalUser">
        Account Name
        <p-sortIcon field="account"></p-sortIcon>
      </th>
      <th scope="col" pSortableColumn="customer">
        Client Name
        <p-sortIcon field="customer"></p-sortIcon>
      </th>
      <th pSortableColumn="qualifiers.orderType" scope="col">
        Order Type
        <p-sortIcon field="qualifiers.orderType"></p-sortIcon>
      </th>
      <th pSortableColumn="date" scope="col" class="hide-lg">
        Ordered Date
        <p-sortIcon field="date"></p-sortIcon>
      </th>
      <th pSortableColumn="ref" scope="col">
        Client Claim Number
        <p-sortIcon field="ref"></p-sortIcon>
      </th>
      <th scope="col">
        Record Subject
      </th>
      <th scope="col" pSortableColumn="by" class="hide-lg">
        Order Owner
        <p-sortIcon field="by"></p-sortIcon>
      </th>
      <th scope="col" pSortableColumn="createdBy" *ngIf="!externalUser" class="hide-lg">
        Created By
        <p-sortIcon field="createdBy"></p-sortIcon>
      </th>
      <th scope="col" pSortableColumn="status">
        Status
        <p-sortIcon field="status"></p-sortIcon>
      </th>
      <th scope="col" aria-label="Action Column">
        <span class="sr-only">Action Column</span>
        <i id="need-help-icon" 
          aria-label=""
          tabindex="0"
          class="pi pi-question-circle pointer"
          style="position: absolute; top: 50%; right: 1rem; transform: translateY(-50%);"
          (mouseenter)="op.show($event)" (mouseleave)="op.hide()">
        </i>
      </th>
    </tr>
  </ng-template>

  <!-- Table body -->
  <ng-template
    pTemplate="body"
    let-order
    let-expanded="expanded"
    let-i="rowIndex"
  >
    <tr>
      <td data-label="Order Number">
        <a
          [routerLink]="['/home/order-details', order.orderNumber]"
          class="p-button p-component p-button-text p-button-link p-0 m-0 text-decoration-none"
        >
          {{ order.orderNumber }}
        </a>
      </td>
      <td data-label="Account Name" *ngIf="!externalUser" valign="top">
        {{ getAccountName(order.orderedByAccountId) }}
      </td>
      <td data-label="Client Name" valign="top" valign="top">
        {{ getClientName(order.customerId) }}
      </td>
      <td data-label="Order Type" valign="top">
        {{ getOrderTypeDisplay(order.qualifiers?.orderType) }}
      </td>
      <td data-label="Order Date" class="hide-lg" valign="top">
        {{ order.orderedDate | dateFormatter:'MM/dd/yyyy' }}
      </td>
      <td data-label="Client Case Number" valign="top">
        {{ order.customerReferenceNumber }}
      </td>
      <td data-label="Record Subject" valign="top" data-openreplay-obscured>{{ order.qualifiers?.plaintiffName }}</td>
      <td data-label="Order Owner" class="hide-lg" valign="top">
        {{ getDisplayName(order.orderedBy)  }}
      </td>
      <td data-label="Created By" *ngIf="!externalUser" class="hide-lg" valign="top">
        {{ getDisplayName(order.createdBy) }}
      </td>
      <td data-label="Status" valign="top">
        {{ getOrderStatusDisplay(order.statusCode) }}
      </td>
      <td data-label="Action" valign="top">
        <div class="d-flex flex-row gap-2 align-items-center">
          <!-- @if(order?.clientActionRequired){ -->
            <i [class.invisible]="!order?.clientActionRequired" role="img" aria-label="client Action Required" class="pi pi-flag-fill" style="color: #D13438;"></i>
          <!-- } -->
          <i tabindex="0"
            [pRowToggler]="order"
            [attr.aria-label]="expanded ? 'Collapse row' : 'Expand row'"
            role="button"
            [ngClass]="
            expanded 
            ? 'pi pi-chevron-circle-up icon-color fs-6'
            : 'pi pi-chevron-circle-down icon-color fs-6' "
            (click)="toggleRow(order.orderNumber, expanded)"
          ></i>
        </div>
      </td>
    </tr>

  </ng-template>

  <ng-template #expandedrow let-order>
    <tr >
      <td [attr.colspan]="externalUser ? 10 : 11" class="bg-pale-blue p-3 expanded">
        <ng-container
          *ngTemplateOutlet="expansionContent; context: { $implicit: order }"
        >
        </ng-container>
      </td>
    </tr>
</ng-template>

  <!-- No Data Placeholder -->
  <ng-template pTemplate="emptymessage">
    <tr>
        <td [attr.colspan]="externalUser ? 9 : 11" class="text-center p-3">
          @if(!loading){
            <div>
              <i>No results found! Please <a href="javascript: void(0)" (click)="contactUs()">contact us</a> if you need assistance.</i>    
            </div>
          }
        </td>
    </tr>
</ng-template>

  <!-- <ng-template pTemplate="paginatorleft">
    <div class="flex align-items-center justify-content-between px-4">
      <span>Total Records: {{ totalRecords }}</span>
    </div>
  </ng-template> -->

  <ng-template #expansionContent let-order>
    <div class="ps-3 ps-sm-0">
      <p-table [value]="recordRequests || []" [loading]="subOrdersLoading">
        <ng-template pTemplate="header">
        <tr>
          <th>Request Number</th>
          <th>Record Subject</th>
          <th>Provider Name</th>
          <th>Record Request Type</th>
          <th>Date of Services</th>
          <th>Status</th>
          <th aria-label="Client Action">
            <span class="sr-only">Client Action</span>
          </th>
        </tr>
      </ng-template>
        <ng-template pTemplate="body" let-doc>
          <tr>
            <td data-label="Order Number">{{ doc?.formattedId }}</td>
            <td data-label="Record Subject" data-openreplay-obscured>{{ doc?.recordSubject }}</td>
            <td data-label="Provider Name">{{ doc?.providerName }}</td>
            <td data-label="Record Request Type">
              {{ doc?.recordRequestType }}
            </td>
            <td data-label="Date of Service">{{ doc?.dateOfServices }}</td>
            <td data-label="Status">{{doc?.status || '--'}}</td>
            <td data-label="Action">
              @if(doc?.clientActionRequired){
                <i class="pi pi-flag-fill" role="img" aria-label="client Action Required" style="color: #D13438;"></i>
              }
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr class="mb-0 border-0">
            <td colspan="7" class="p-3 empty-message">
              No documents found for this order.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </ng-template>

  <p-popover #op styleClass="help-icon-popover">
    <div>
        <label class="fw-semibold">Icon Overview </label>
        <p>This section describes the icons displayed on this screen.</p>
    </div>
    <ul class="dropdown-menu-list">
      <li class="d-flex flex-row align-items-center"><i class="pi pi-flag-fill icon-color-red me-2" style="color: #D13438;"></i>Client Action</li>
      <li class="d-flex flex-row align-items-center"><i class="pi pi-chevron-circle-down icon-color me-2"></i>Expand</li>
    </ul>
  </p-popover>
</p-table>

<!-- add dialogs here -->
<app-modal [header]="'Need Help'" [(showDialog)]="showHelpModal" [acceptLabel]="'Close'"
  (acceptModalClick)="showHelpModal = false">
  <app-need-help-modal></app-need-help-modal>
</app-modal>

